import { render, staticRenderFns } from "./ScreenLaudoPelvica.vue?vue&type=template&id=b3445f06&lang=true&"
import script from "./ScreenLaudoPelvica.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoPelvica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports